module.exports = __webpack_public_path__ + "img/delete.8286e474.svg";